import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { QueryBase } from "src/app/libs/data-access/store/shared/query-base.interface";
import { HotelsState } from "../model";
import { HotelsStateActions } from "../store";
import { HotelsSelectors } from "../store/hotels.selectors";

@Injectable({
  providedIn: "root",
})
export class HotelsQuery implements QueryBase {
  hotels$ = this.hotelsStore.select(HotelsSelectors.getHotels);
  active$ = this.hotelsStore.select(HotelsSelectors.getActive);
  filtersMetadata$ = this.hotelsStore.select(HotelsSelectors.getFilterMetadata);
  requestMetadata$ = this.hotelsStore.select(
    HotelsSelectors.getRequestMetadata
  );
  sort$ = this.hotelsStore.select(HotelsSelectors.getSortValue);
  totalRecordsLeft$ = this.hotelsStore.select(
    HotelsSelectors.getTotalRecordsLeft
  );
  totalRecords$ = this.hotelsStore.select(
    HotelsSelectors.getTotalRecords
  );
  selectedQuickFilter$ = this.hotelsStore.select(
    HotelsSelectors.getSelectedQuickFilter
  );
  loadMoreActions$ = this.hotelsStore.select(
    HotelsSelectors.getLoadMoreActions
  );
  loading$ = this.hotelsStore.select(HotelsSelectors.getLoading);
  loaded$ = this.hotelsStore.select(HotelsSelectors.getLoaded);
  errors$ = this.hotelsStore.select(HotelsSelectors.getLoaded);

  constructor(private hotelsStore: Store<HotelsState>) {}

  getAllHotels() {
    return this.hotelsStore.select(HotelsSelectors.getHotels);
  }
  selectHotelById(id: string | number) {
    //TODO: complete types
    return this.hotelsStore.select(HotelsSelectors.getHotelById(id));
  }
  saveFilterConfiguration(metadata: any): void {
    //TODO: complete types
    this.hotelsStore.dispatch(
      HotelsStateActions.saveHotelFilterConfiguration({ metadata })
    );
  }
  loadHotelFilterOptions(requestQuery: any): void {
    //TODO: complete types
    this.hotelsStore.dispatch(
      HotelsStateActions.loadHotelsFilterOptions({ requestQuery })
    );
  }
  loadHotelsData(requestQuery: any): void {
    //TODO: complete types
    this.hotelsStore.dispatch(
      HotelsStateActions.loadHotelsData({ requestQuery })
    );
  }
  loadMoreHotelsData(requestQuery: any): void {
    //TODO: complete types
    this.hotelsStore.dispatch(
      HotelsStateActions.loadMoreHotelsData({ requestQuery })
    );
  }

  setQuickFilter(selectedQuickFilter: any): void {
    //TODO: Complete type
    this.hotelsStore.dispatch(
      HotelsStateActions.setQuickFilter({ selectedQuickFilter})
    );
  }
}
